// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aplica as classes passadas no host do componente */
:host {
  display: block;
  width: 100%;
}

/* Para garantir que o mat-form-field ocupe toda a largura disponível */
mat-form-field {
  width: 100%;
}

/* Estilos opcionais para melhorar a aparência */
.mat-mdc-form-field {
  width: 100%;
}

/* Se precisar de ajustes específicos para o datepicker toggle */
.mat-datepicker-toggle {
  cursor: pointer;
}

/* Ajuste para o input com máscara se necessário */
input[mask] {
  font-family: inherit;
}

.custom-error {
  margin-top: -22px; /* Cola na base do input */
  width: 100%; /* Mesma largura do input */
  min-height: 22px; /* Altura mínima para evitar "pulo" */
  display: flex;
  justify-content: flex-end; /* Alinha conteúdo à direita */
  line-height: 1.2;
}

.custom-error small {
  margin-left: auto; /* Força o small para a direita */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/date-picker/date-picker.component.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,cAAc;EACd,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE,WAAW;AACb;;AAEA,gEAAgE;AAChE;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,WAAW,EAAE,2BAA2B;EACxC,gBAAgB,EAAE,qCAAqC;EACvD,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD","sourcesContent":["/* Aplica as classes passadas no host do componente */\n:host {\n  display: block;\n  width: 100%;\n}\n\n/* Para garantir que o mat-form-field ocupe toda a largura disponível */\nmat-form-field {\n  width: 100%;\n}\n\n/* Estilos opcionais para melhorar a aparência */\n.mat-mdc-form-field {\n  width: 100%;\n}\n\n/* Se precisar de ajustes específicos para o datepicker toggle */\n.mat-datepicker-toggle {\n  cursor: pointer;\n}\n\n/* Ajuste para o input com máscara se necessário */\ninput[mask] {\n  font-family: inherit;\n}\n\n.custom-error {\n  margin-top: -22px; /* Cola na base do input */\n  width: 100%; /* Mesma largura do input */\n  min-height: 22px; /* Altura mínima para evitar \"pulo\" */\n  display: flex;\n  justify-content: flex-end; /* Alinha conteúdo à direita */\n  line-height: 1.2;\n}\n\n.custom-error small {\n  margin-left: auto; /* Força o small para a direita */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
